export class LocationPreference {
    id: string;
    name: string;
    avatar_url?: string;
    scheduleId: string;
}
